import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "姓名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "客户编号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "跟进人"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"40%"}
    }, "跟进内容"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"180px"}
    }, "跟进时间")
  ])
], -1)
const _hoisted_6 = { id: "member-list" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ml-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.exportData && $setup.exportData(...args)))
        }, "导出")
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customers, (value, idx) => {
            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
              _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
              _createElementVNode("td", null, _toDisplayString(value.profile?.name || "未提供"), 1),
              _createElementVNode("td", null, _toDisplayString(value.profile?.id || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(value.operatorName || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(value.detail || "-"), 1),
              (value.operateDate)
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(value.operateDate + " " + (value.clockTime || '')), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString($setup.dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))), 1))
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_Pagination, {
        page: $setup.nowPage,
        max: $setup.totalPage/50,
        onLoadPage: $setup.loadCustomerList
      }, null, 8, ["page", "max", "onLoadPage"])
    ])
  ]))
}